import { imageOrVideoFields, richTextFields } from '@/data/sanity/fragments/_shared'
import cmsSettings from '../cmsSettings'
import { link } from '@/data/sanity/fragments'

export const fields = `
  _type,
  _id,
  ${cmsSettings()},
  title[]{${richTextFields}},
  media {
    ${imageOrVideoFields}
  },
  reviews[] {
    text,
    author
  },
  ${link.fragment('nextSectionLink')},
  ${link.fragment('buttonLink')}
`

export const fragment = (name = 'homepageHero') => `${name}{ ${fields} }`

const exported = {
  fields,
  fragment,
}

export default exported
